module.exports = __webpack_public_path__ + "img/partner-linkedin@2x.ddafda87.png";